import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const ReturnArrowIcon = ({ fill, height, viewBox, width, ...rest }) => (
    <SvgIcon height={height} viewBox={viewBox} width={width} {...rest}>
        <path
            d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2Z"
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
        />
    </SvgIcon>
);

ReturnArrowIcon.propTypes = {
    fill: string,
    height: string,
    viewBox: string,
    width: string,
};

ReturnArrowIcon.defaultProps = {
    fill: MIGRATED_COLORS.black,
    height: '20',
    viewBox: '0 0 24 24',
    width: '20',
};

export default ReturnArrowIcon;
